const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const UTC_MIDNIGHT_PATTERN = /^(\d{4})-(\d{2})-(\d{2})T00:00:00(?:\.000)?Z$/;

export const getDatePartsFromString = (value) => {
  if (typeof value !== 'string') return null;
  const text = value.trim();
  const match = text.match(DATE_ONLY_PATTERN) || text.match(UTC_MIDNIGHT_PATTERN);
  if (!match) return null;
  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
};

export const getUtcMidnightDateParts = (value) => {
  const match = typeof value === 'string' ? value.trim().match(UTC_MIDNIGHT_PATTERN) : null;
  if (!match) return null;
  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
};

export const isUtcMidnightTimestamp = (value) => Boolean(getUtcMidnightDateParts(value));

export const formatDateParts = (parts) => {
  if (!parts) return '';
  return `${parts.month}/${parts.day}/${parts.year}`;
};

export const formatCalendarDate = (value) => {
  if (!value) return '';
  const parts = getDatePartsFromString(value);
  if (parts) return formatDateParts(parts);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US');
};

export const formatDateTimeConsistent = (value, options = undefined) => {
  if (!value) return '';
  const parts = getUtcMidnightDateParts(value);
  if (parts) {
    return new Date(parts.year, parts.month - 1, parts.day, 0, 0, 0).toLocaleString('en-US', options);
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-US', options);
};

export const formatDateInputValue = (value) => {
  if (!value) return '';
  const parts = getDatePartsFromString(value);
  if (parts) {
    return [
      parts.year,
      String(parts.month).padStart(2, '0'),
      String(parts.day).padStart(2, '0'),
    ].join('-');
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
};

export const dateSortValue = (value) => {
  const parts = getDatePartsFromString(value);
  if (parts) return Date.UTC(parts.year, parts.month - 1, parts.day);
  const date = new Date(value || 0);
  const time = date.getTime();
  return Number.isFinite(time) ? time : 0;
};
